import classNames from 'classnames';
import { SelectHTMLAttributes } from 'react';

export interface SelectOptionProps {
  value: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  inputClassName?: string;
  error?: string | boolean;
  // value: string;
  label?: string | React.ReactElement;
  labelIcon?: React.ReactElement;
  options: SelectOptionProps[];
  labelRef?: React.RefObject<HTMLLabelElement | null>;
  ref?: React.RefObject<HTMLSelectElement | null>;
}

function Select({
  className,
  inputClassName,
  // value,
  label,
  error,
  options,
  disabled = false,
  labelIcon,
  labelRef,
  ref: selectRef,
  ...rest
}: SelectProps) {
  return (
    <div className={classNames('mb-2', className)}>
      <label
        className={classNames(
          'text-heading flex flex-col font-semibold',
          label && error && 'text-red-600'
        )}
        ref={labelRef}
      >
        {label && (
          <div className="mb-1 flex min-h-5 items-center gap-1 leading-none">
            {labelIcon && <div>{labelIcon}</div>}
            <div>{label}</div>
          </div>
        )}
        <div className="">
          <select
            className={classNames(
              'h-11 w-full rounded border border-neutral-500 bg-white p-2 font-normal outline-offset-1 outline-none',
              disabled && 'border-neutral-500/30 text-neutral-500',
              error && 'border-red-600 text-red-600',
              'focus:outline-4 focus:outline-blue-200 focus:outline-solid',
              inputClassName
            )}
            // value={value}
            disabled={disabled}
            ref={selectRef}
            {...rest}
          >
            {options?.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
      </label>
      {error && typeof error === 'string' && (
        <div className="mt-2 rounded bg-red-50 px-2 py-1 text-red-700">{error}</div>
      )}
    </div>
  );
}

export default Select;
